/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Device No Groups Option Icon component.
 */
export const DeviceNoGroupsOptionIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5 0H0.5C0.223858 0 0 0.223857 0 0.5V5H1.5V1.5H5V0ZM5 18.5H1.5V15H0V19.5C0 19.7761 0.223857 20 0.5 20H5V18.5ZM15 20V18.5H18.5V15H20V19.5C20 19.7761 19.7761 20 19.5 20H15ZM15 1.5V0H19.5C19.7761 0 20 0.223858 20 0.5V5H18.5V1.5H15Z" fill={iconColor}/>
      <path d="M11.9167 12.3234C12.4872 12.1775 12.9925 11.8449 13.3523 11.3787C13.7121 10.9125 13.9056 10.3394 13.9022 9.75048C13.8988 9.1616 13.6985 8.59078 13.3333 8.12881C12.9681 7.66683 12.4589 7.34021 11.8867 7.20094" stroke={iconColor} strokeMiterlimit="10"/>
      <path d="M12.7266 5.59156C13.6566 5.82023 14.4838 6.35269 15.077 7.10458C15.6702 7.85647 15.9956 8.78481 16.0016 9.74252C16.0077 10.7002 15.6939 11.6326 15.1102 12.3919C14.6097 13.043 13.9351 13.5349 13.1685 13.8134" stroke={iconColor} strokeMiterlimit="10"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M5.80469 4.59156L14.0866 15.8792L14.8928 15.2876L10.5564 9.37736V7.41383C10.5564 7.13769 10.3325 6.91383 10.0564 6.91383H8.74886L6.61095 4L5.80469 4.59156ZM3.5 6.91383H6.26967L10.3631 12.4929C10.2784 12.5587 10.172 12.598 10.0564 12.598H3.5C3.22386 12.598 3 12.3741 3 12.098V7.41383C3 7.13769 3.22386 6.91383 3.5 6.91383Z" fill={iconColor}/>
    </svg>
  );
};

export default DeviceNoGroupsOptionIcon;
